<template>
  <section class="form">
    <card-component title="Upload Learners" icon="ballot">
      <div>
        Select an end date for these users subscriptions. If no date is selected
        they will be entered as unsubscribed.
      </div>
      <b-field label="Subscription end date" horizontal>
        <b-datepicker
          placeholder="Click to select..."
          v-model="form.subscriptionDate"
        >
        </b-datepicker>
      </b-field>
      <b-field
        class="file"
        :class="{ 'is-success': form.projectId, 'has-name': !!file }"
      >
        <b-upload v-model="file" class="file-label">
          <span class="file-cta">
            <b-icon class="file-icon" icon="upload"></b-icon>
            <span class="file-label">Upload Spreadsheet</span>
          </span>
          <span class="file-name" v-if="file">
            {{ file.name }}
          </span>
        </b-upload>
      </b-field>
      <xlsx-read :file="file">
        <xlsx-json :sheet="0">
          <template #default="{collection}">
            <b-loading
              style="z-index: 100;"
              :is-full-page="true"
              :active="file && !collection"
              :can-cancel="false"
            >
              <div class="loading-container">
                <div class="loading">
                  <p>loading</p>
                  <span></span>
                </div>
              </div>
            </b-loading>
            <div v-if="collection && file">
              <hr />
              <b-table
                v-if="collection"
                :bordered="true"
                :striped="true"
                :narrowed="true"
                :data="collection"
                :columns="columns"
              >
              </b-table>
              <hr />
              <div>
                Please ensure you double checked:
              </div>
              <span>
                <ul>
                  <li>- All email addresses are properly formatted.</li>
                  <li>- All passwords are more than 6 characters.</li>
                  <li>- The school fields are all identical</li>
                  <li>- The project fields are all identical</li>
                </ul>
              </span>
              <hr />
              <div>
                If you have spotted an error press Reset and re-upload the
                corrected sheet.
              </div>
              <div>
                Otherwise if you are happy, press Submit!
              </div>
              <hr />

              <b-message
                v-if="submitMessage"
                title="Submission Results"
                :type="submitMessage.submitted ? 'is-info' : 'is-danger'"
              >
                <span
                  v-for="text in submitMessage.message.split('$$')"
                  :key="text"
                >
                  <div v-if="checkText(text)" style="color:#FFA500">
                    {{ text.replace(",", " ") }}
                  </div>
                  <div v-else>
                    {{ text.replace(",", " ") }}
                  </div>
                  <br />
                </span>
              </b-message>
              <b-field grouped>
                <div class="control">
                  <b-button
                    type="is-primary is-success is-outlined"
                    @click="reset()"
                    v-html="'Reset'"
                  />
                </div>
                <div class="control">
                  <b-button
                    type="is-primary is-success"
                    @click="submit(collection)"
                    v-html="'Submit'"
                  />
                </div>
              </b-field>
            </div>
          </template>
        </xlsx-json>
      </xlsx-read>
    </card-component>
  </section>
</template>

<script>
import CardComponent from "@/components/CardComponent";
import mapValues from "lodash/mapValues";
import { XlsxRead, XlsxJson } from "vue-xlsx";
import { mapState, mapActions } from "vuex";

export default {
  name: "UploadLearnerComponent",
  components: {
    CardComponent,
    XlsxRead,
    XlsxJson
  },
  data() {
    return {
      isLoading: false,
      form: {
        subscriptionDate: null,
        content: null
      },
      file: null,
      collection: null,
      submission: null,
      submitMessage: null,
      errorMessage:
        "Couldn't generate user id. Please check email and password validity.",
      columns: [
        {
          field: "firstName",
          label: "First Name",
          width: "40"
        },
        {
          field: "lastName",
          label: "Last Name",
          width: "40"
        },
        {
          field: "preferredName",
          label: "Preferred Name",
          width: "40"
        },
        {
          field: "email",
          label: "Email",
          width: "40"
        },
        {
          field: "password",
          label: "Password",
          width: "40"
        },
        {
          field: "grade",
          label: "Grade",
          width: "20",
          numeric: true
        },
        {
          field: "class",
          label: "Class",
          width: "20"
        },
        {
          field: "school",
          label: "School",
          width: "80"
        },
        {
          field: "project",
          label: "Project",
          width: "40"
        },
        {
          field: "cellphone",
          label: "Cellphone",
          width: "40"
        },
        {
          field: "gender",
          label: "Gender",
          width: "40"
        },
        {
          field: "birthdate",
          label: "Birthdate",
          width: "40"
        },
        {
          field: "uniqueId",
          label: "Unique ID",
          width: "40"
        },
        {
          field: "studentNumber",
          label: "Student Number",
          width: "40"
        },
        {
          field: "language",
          label: "Language",
          width: "40"
        },
        {
          field: "subject",
          label: "Subject",
          width: "40"
        },
        {
          field: "lockedJourneys",
          label: "Locked Journeys",
          width: "20"
        }
      ]
    };
  },
  computed: {
    ...mapState({
      user: "user",
      projects: state => state.globalStore.projects
    })
  },
  methods: {
    ...mapActions({
      submitLearners: "adminStore/submitLearners",
      loading: "SET_SCREEN_LOADING"
    }),
    onChange(event) {
      this.file = event.target.files ? event.target.files[0] : null;
    },
    async submit(collection) {
      this.loading(true);
      this.form.content = collection;
      this.submitMessage = await this.submitLearners(this.form);
      this.loading(false);
    },
    reset() {
      this.file = null;
      this.submitMessage = null;
      this.collection = null;
      this.form = mapValues(this.form, item => {
        if (item && typeof item === "object") {
          return [];
        }
        return null;
      });
    },
    checkText(val) {
      return val.includes(this.errorMessage);
    }
  }
};
</script>
